import React from "react";

import Container from "@components/container";
import Section from "@components/section";
import Box from "@components/box";

import styles from "./video.module.scss";
import videoPath from "@images/final.mp4";

const Video = () => {
  return (
    <Section
      title={[["GATHER", "THIS", "SUMMER"], ["相聚今夏"]]}
      headerWithContainer
    >
      <Container>
        <Container.Wide>
          <Box className={styles.box}>
            <div className="video">
              <div>
                <video src={videoPath} controls></video>
              </div>
            </div>
          </Box>
        </Container.Wide>
      </Container>
      <Container>
        <p className={styles.text}>
          Gfest是一次全新的尝试与开始，我们尝试联合国内国外的很多优秀游戏开发者一起为中国的玩家带来这样一场线上活动，希望它在未来可以积累越来越多的能量来服务所有玩家们。同时我们也始终期待着与大家面对面相遇的时刻，在那之前，让我们先线上聚一次！
        </p>
      </Container>
    </Section>
  );
};

export default Video;
